export default __webpack_public_path__ + "static/media/share.bdbc648f.svg";